@file:OptIn(InternalResourceApi::class)

package top.features.venues.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.features.venues.generated.resources/"

@delegate:ResourceContentHash(-270_716_214)
internal val Res.string.venue_location_loading: StringResource by lazy {
      StringResource("string:venue_location_loading", "venue_location_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16574, 94),
      ))
    }

@delegate:ResourceContentHash(761_676_807)
internal val Res.string.venue_location_relevance_format: StringResource by lazy {
      StringResource("string:venue_location_relevance_format", "venue_location_relevance_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16669, 87),
      ))
    }

@delegate:ResourceContentHash(1_394_272_167)
internal val Res.string.venue_location_title: StringResource by lazy {
      StringResource("string:venue_location_title", "venue_location_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16757, 72),
      ))
    }

@delegate:ResourceContentHash(1_669_529_656)
internal val Res.string.venue_location_type_format: StringResource by lazy {
      StringResource("string:venue_location_type_format", "venue_location_type_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16830, 50),
      ))
    }

@delegate:ResourceContentHash(-859_928_453)
internal val Res.string.venue_main_info_category_label: StringResource by lazy {
      StringResource("string:venue_main_info_category_label", "venue_main_info_category_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16881, 62),
      ))
    }

@delegate:ResourceContentHash(-1_282_709_283)
internal val Res.string.venue_main_info_category_placeholder: StringResource by lazy {
      StringResource("string:venue_main_info_category_placeholder", "venue_main_info_category_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16944, 64),
      ))
    }

@delegate:ResourceContentHash(-13_657_303)
internal val Res.string.venue_main_info_description_label: StringResource by lazy {
      StringResource("string:venue_main_info_description_label", "venue_main_info_description_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17009, 53),
      ))
    }

@delegate:ResourceContentHash(1_532_474_039)
internal val Res.string.venue_main_info_name_label: StringResource by lazy {
      StringResource("string:venue_main_info_name_label", "venue_main_info_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17063, 70),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.venue_main_info_phone_label: StringResource by lazy {
      StringResource("string:venue_main_info_phone_label", "venue_main_info_phone_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17134, 71),
      ))
    }

@delegate:ResourceContentHash(1_109_627_363)
internal val Res.string.venue_main_info_title: StringResource by lazy {
      StringResource("string:venue_main_info_title", "venue_main_info_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17206, 77),
      ))
    }

@delegate:ResourceContentHash(-331_202_898)
internal val Res.string.venue_main_info_website_label: StringResource by lazy {
      StringResource("string:venue_main_info_website_label", "venue_main_info_website_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17284, 49),
      ))
    }

@delegate:ResourceContentHash(-1_214_304_205)
internal val Res.string.venue_moderator_selector_placeholder: StringResource by lazy {
      StringResource("string:venue_moderator_selector_placeholder", "venue_moderator_selector_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17334, 80),
      ))
    }

@delegate:ResourceContentHash(-979_845_109)
internal val Res.string.venue_moderator_selector_title_prefix: StringResource by lazy {
      StringResource("string:venue_moderator_selector_title_prefix", "venue_moderator_selector_title_prefix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17415, 73),
      ))
    }

@delegate:ResourceContentHash(859_675_006)
internal val Res.string.venue_owner_email_label: StringResource by lazy {
      StringResource("string:venue_owner_email_label", "venue_owner_email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17489, 75),
      ))
    }

@delegate:ResourceContentHash(-1_055_234_770)
internal val Res.string.venue_owner_first_name_label: StringResource by lazy {
      StringResource("string:venue_owner_first_name_label", "venue_owner_first_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17565, 48),
      ))
    }

@delegate:ResourceContentHash(1_055_236_886)
internal val Res.string.venue_owner_last_name_label: StringResource by lazy {
      StringResource("string:venue_owner_last_name_label", "venue_owner_last_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17614, 59),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.venue_owner_phone_label: StringResource by lazy {
      StringResource("string:venue_owner_phone_label", "venue_owner_phone_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17674, 67),
      ))
    }

@delegate:ResourceContentHash(-1_404_957_486)
internal val Res.string.venue_owner_title: StringResource by lazy {
      StringResource("string:venue_owner_title", "venue_owner_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17742, 45),
      ))
    }

@delegate:ResourceContentHash(186_220_019)
internal val Res.string.venue_role_moderator: StringResource by lazy {
      StringResource("string:venue_role_moderator", "venue_role_moderator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17788, 52),
      ))
    }

@delegate:ResourceContentHash(1_904_736_781)
internal val Res.string.venue_role_super_admin: StringResource by lazy {
      StringResource("string:venue_role_super_admin", "venue_role_super_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17841, 58),
      ))
    }

@delegate:ResourceContentHash(-713_382_111)
internal val Res.string.venue_schedule_title: StringResource by lazy {
      StringResource("string:venue_schedule_title", "venue_schedule_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17900, 64),
      ))
    }

@delegate:ResourceContentHash(-1_368_652_560)
internal val Res.string.venue_service_add: StringResource by lazy {
      StringResource("string:venue_service_add", "venue_service_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17965, 61),
      ))
    }

@delegate:ResourceContentHash(1_047_255_787)
internal val Res.string.venue_service_card_title: StringResource by lazy {
      StringResource("string:venue_service_card_title", "venue_service_card_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18027, 100),
      ))
    }

@delegate:ResourceContentHash(1_902_991_997)
internal val Res.string.venue_service_save_draft: StringResource by lazy {
      StringResource("string:venue_service_save_draft", "venue_service_save_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18128, 76),
      ))
    }

@delegate:ResourceContentHash(40_969_491)
internal val Res.string.venue_service_submit: StringResource by lazy {
      StringResource("string:venue_service_submit", "venue_service_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18205, 88),
      ))
    }

@delegate:ResourceContentHash(-2_057_160_428)
internal val Res.string.venue_service_upload_file: StringResource by lazy {
      StringResource("string:venue_service_upload_file", "venue_service_upload_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18294, 81),
      ))
    }

@delegate:ResourceContentHash(-1_180_001_131)
internal val Res.string.venue_status_added_by_moderator: StringResource by lazy {
      StringResource("string:venue_status_added_by_moderator", "venue_status_added_by_moderator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18376, 79),
      ))
    }

@delegate:ResourceContentHash(1_472_540_861)
internal val Res.string.venue_status_application: StringResource by lazy {
      StringResource("string:venue_status_application", "venue_status_application", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18456, 48),
      ))
    }

@delegate:ResourceContentHash(-2_070_063_352)
internal val Res.string.venue_status_check_changes: StringResource by lazy {
      StringResource("string:venue_status_check_changes", "venue_status_check_changes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18505, 78),
      ))
    }

@delegate:ResourceContentHash(-852_139_779)
internal val Res.string.venue_status_closed: StringResource by lazy {
      StringResource("string:venue_status_closed", "venue_status_closed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18584, 51),
      ))
    }

@delegate:ResourceContentHash(1_416_971_042)
internal val Res.string.venue_status_connected: StringResource by lazy {
      StringResource("string:venue_status_connected", "venue_status_connected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18636, 58),
      ))
    }

@delegate:ResourceContentHash(-432_377_855)
internal val Res.string.venue_status_draft: StringResource by lazy {
      StringResource("string:venue_status_draft", "venue_status_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18695, 50),
      ))
    }

@delegate:ResourceContentHash(356_607_266)
internal val Res.string.venue_status_pending_review: StringResource by lazy {
      StringResource("string:venue_status_pending_review", "venue_status_pending_review", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18746, 67),
      ))
    }

@delegate:ResourceContentHash(1_079_909_743)
internal val Res.string.venue_status_rejected: StringResource by lazy {
      StringResource("string:venue_status_rejected", "venue_status_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18814, 53),
      ))
    }

@delegate:ResourceContentHash(-1_658_069_719)
internal val Res.string.venue_success_blocked_message: StringResource by lazy {
      StringResource("string:venue_success_blocked_message", "venue_success_blocked_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18868, 85),
      ))
    }

@delegate:ResourceContentHash(1_953_301_684)
internal val Res.string.venue_success_blocked_title: StringResource by lazy {
      StringResource("string:venue_success_blocked_title", "venue_success_blocked_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18954, 51),
      ))
    }

@delegate:ResourceContentHash(1_196_565_623)
internal val Res.string.venue_success_create_message: StringResource by lazy {
      StringResource("string:venue_success_create_message", "venue_success_create_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19006, 96),
      ))
    }

@delegate:ResourceContentHash(1_953_301_684)
internal val Res.string.venue_success_create_title: StringResource by lazy {
      StringResource("string:venue_success_create_title", "venue_success_create_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19103, 50),
      ))
    }

@delegate:ResourceContentHash(-554_452_804)
internal val Res.string.venue_success_update_message: StringResource by lazy {
      StringResource("string:venue_success_update_message", "venue_success_update_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19154, 96),
      ))
    }

@delegate:ResourceContentHash(1_953_301_684)
internal val Res.string.venue_success_update_title: StringResource by lazy {
      StringResource("string:venue_success_update_title", "venue_success_update_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19251, 50),
      ))
    }

@delegate:ResourceContentHash(437_001_736)
internal val Res.string.venue_tab_services: StringResource by lazy {
      StringResource("string:venue_tab_services", "venue_tab_services", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19302, 46),
      ))
    }

@delegate:ResourceContentHash(-1_084_868_462)
internal val Res.string.venue_tab_venue: StringResource by lazy {
      StringResource("string:venue_tab_venue", "venue_tab_venue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19349, 39),
      ))
    }

@delegate:ResourceContentHash(1_490_221_713)
internal val Res.string.venue_table_col_actions: StringResource by lazy {
      StringResource("string:venue_table_col_actions", "venue_table_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19389, 39),
      ))
    }

@delegate:ResourceContentHash(-859_928_453)
internal val Res.string.venue_table_col_category: StringResource by lazy {
      StringResource("string:venue_table_col_category", "venue_table_col_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19429, 56),
      ))
    }

@delegate:ResourceContentHash(-764_980_442)
internal val Res.string.venue_table_col_date: StringResource by lazy {
      StringResource("string:venue_table_col_date", "venue_table_col_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19486, 40),
      ))
    }

@delegate:ResourceContentHash(859_675_006)
internal val Res.string.venue_table_col_email: StringResource by lazy {
      StringResource("string:venue_table_col_email", "venue_table_col_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19527, 73),
      ))
    }

@delegate:ResourceContentHash(186_220_019)
internal val Res.string.venue_table_col_moderator: StringResource by lazy {
      StringResource("string:venue_table_col_moderator", "venue_table_col_moderator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19601, 57),
      ))
    }

@delegate:ResourceContentHash(-1_146_223_278)
internal val Res.string.venue_table_col_name: StringResource by lazy {
      StringResource("string:venue_table_col_name", "venue_table_col_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19659, 44),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.venue_table_col_phone: StringResource by lazy {
      StringResource("string:venue_table_col_phone", "venue_table_col_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19704, 65),
      ))
    }

@delegate:ResourceContentHash(1_522_781_474)
internal val Res.string.venue_table_col_status: StringResource by lazy {
      StringResource("string:venue_table_col_status", "venue_table_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19770, 46),
      ))
    }

@delegate:ResourceContentHash(2_343_909)
internal val Res.string.venue_table_placeholder_dash: StringResource by lazy {
      StringResource("string:venue_table_placeholder_dash", "venue_table_placeholder_dash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19817, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("venue_location_loading", Res.string.venue_location_loading)
  map.put("venue_location_relevance_format", Res.string.venue_location_relevance_format)
  map.put("venue_location_title", Res.string.venue_location_title)
  map.put("venue_location_type_format", Res.string.venue_location_type_format)
  map.put("venue_main_info_category_label", Res.string.venue_main_info_category_label)
  map.put("venue_main_info_category_placeholder", Res.string.venue_main_info_category_placeholder)
  map.put("venue_main_info_description_label", Res.string.venue_main_info_description_label)
  map.put("venue_main_info_name_label", Res.string.venue_main_info_name_label)
  map.put("venue_main_info_phone_label", Res.string.venue_main_info_phone_label)
  map.put("venue_main_info_title", Res.string.venue_main_info_title)
  map.put("venue_main_info_website_label", Res.string.venue_main_info_website_label)
  map.put("venue_moderator_selector_placeholder", Res.string.venue_moderator_selector_placeholder)
  map.put("venue_moderator_selector_title_prefix", Res.string.venue_moderator_selector_title_prefix)
  map.put("venue_owner_email_label", Res.string.venue_owner_email_label)
  map.put("venue_owner_first_name_label", Res.string.venue_owner_first_name_label)
  map.put("venue_owner_last_name_label", Res.string.venue_owner_last_name_label)
  map.put("venue_owner_phone_label", Res.string.venue_owner_phone_label)
  map.put("venue_owner_title", Res.string.venue_owner_title)
  map.put("venue_role_moderator", Res.string.venue_role_moderator)
  map.put("venue_role_super_admin", Res.string.venue_role_super_admin)
  map.put("venue_schedule_title", Res.string.venue_schedule_title)
  map.put("venue_service_add", Res.string.venue_service_add)
  map.put("venue_service_card_title", Res.string.venue_service_card_title)
  map.put("venue_service_save_draft", Res.string.venue_service_save_draft)
  map.put("venue_service_submit", Res.string.venue_service_submit)
  map.put("venue_service_upload_file", Res.string.venue_service_upload_file)
  map.put("venue_status_added_by_moderator", Res.string.venue_status_added_by_moderator)
  map.put("venue_status_application", Res.string.venue_status_application)
  map.put("venue_status_check_changes", Res.string.venue_status_check_changes)
  map.put("venue_status_closed", Res.string.venue_status_closed)
  map.put("venue_status_connected", Res.string.venue_status_connected)
  map.put("venue_status_draft", Res.string.venue_status_draft)
  map.put("venue_status_pending_review", Res.string.venue_status_pending_review)
  map.put("venue_status_rejected", Res.string.venue_status_rejected)
  map.put("venue_success_blocked_message", Res.string.venue_success_blocked_message)
  map.put("venue_success_blocked_title", Res.string.venue_success_blocked_title)
  map.put("venue_success_create_message", Res.string.venue_success_create_message)
  map.put("venue_success_create_title", Res.string.venue_success_create_title)
  map.put("venue_success_update_message", Res.string.venue_success_update_message)
  map.put("venue_success_update_title", Res.string.venue_success_update_title)
  map.put("venue_tab_services", Res.string.venue_tab_services)
  map.put("venue_tab_venue", Res.string.venue_tab_venue)
  map.put("venue_table_col_actions", Res.string.venue_table_col_actions)
  map.put("venue_table_col_category", Res.string.venue_table_col_category)
  map.put("venue_table_col_date", Res.string.venue_table_col_date)
  map.put("venue_table_col_email", Res.string.venue_table_col_email)
  map.put("venue_table_col_moderator", Res.string.venue_table_col_moderator)
  map.put("venue_table_col_name", Res.string.venue_table_col_name)
  map.put("venue_table_col_phone", Res.string.venue_table_col_phone)
  map.put("venue_table_col_status", Res.string.venue_table_col_status)
  map.put("venue_table_placeholder_dash", Res.string.venue_table_placeholder_dash)
}
